import { Component } from '@angular/core'
import { BaseCellComponent } from './base-cell.component'

type LinkCellComponentProps<D> = Readonly<{
  display: (data: D) => string;
  url: (data: D) => string;
  isVisible: (data:D) => boolean
}>

@Component({
  selector: 'a[app-link-cell]',
  template: '@if(params.data) {{{ params.display(params.data) }}}',
  host: {
    '[href]': 'params.data && !!params.url  ? params.url(params.data): "#"',
    'target': '_blank',
    '[class.invisible]': 'params.data && !!params.isVisible ? !params.isVisible(params.data): true',
  },
})
export class LinkCellComponent<
  DATA,
  FIELD extends keyof DATA,
> extends BaseCellComponent<
    DATA,
    LinkCellComponentProps<DATA>,
    FIELD
  > { }
